<template>
  <div class="next-card">
    <h1 class="title">
      What’s Next:
    </h1>
    <div v-if="$route.path.includes('/results/') || data.testScore.score >= 60" class="btn-results">
      <div class="btn-holder">
        <button v-if="data.testScore.score >= 60" class="btn-outline-dark-light-4 btn" @click="shareResult">
          <ShareIcon /> Share Your Result
        </button>
        <button v-else class="btn-outline-dark-light-4 btn" @click="reloadDeck">
          <ReloadDeck /> Reload Deck
        </button>
        <nuxt-link class="btn-outline-dark-light-4 btn" to="/flashcards/">
          <BrowseDeck /> Browse More Decks
        </nuxt-link>
        <nuxt-link class="btn-outline-dark-light-4 btn" :to="`/flashcards/${$route.params.slug}/test/`">
          <TakeTest /> Take Another Test
        </nuxt-link>
        <button v-if="data.testScore.score < 60" class="btn-outline-dark-light-4 btn" @click="shareResult">
          <ShareIcon /> Share Your Result
        </button>
        <button v-else class="btn-outline-dark-light-4 btn" @click="reloadDeck">
          <ReloadDeck /> Reload Deck
        </button>
      </div>
    </div>
    <div v-else class="btn-preview">
      <div v-if="review" class="btn-holder">
        <nuxt-link class="btn-outline-dark-light-4 btn" :to="`/flashcards/${$route.params.slug}/review/`">
          <ContinueReviewing /> Continue Reviewing
        </nuxt-link>
        <nuxt-link class="btn-outline-dark-light-4 btn" :to="`/flashcards/${$route.params.slug}/study/`">
          <ReloadDeck /> Study Deck
        </nuxt-link>
        <nuxt-link class="btn-outline-dark-light-4 btn" :to="`/flashcards/${$route.params.slug}/test/`">
          <TakeTest /> {{ testBtnText }}
        </nuxt-link>
        <nuxt-link class="btn-outline-dark-light-4 btn" to="/flashcards/">
          <BrowseDeck /> Browse More Decks
        </nuxt-link>
      </div>
      <div v-else class="btn-holder">
        <nuxt-link class="btn-outline-dark-light-4 btn" :to="`/flashcards/${$route.params.slug}/test/`">
          <TakeTest /> {{ testBtnText }}
        </nuxt-link>
        <button class="btn-outline-dark-light-4 btn" @click="loadDifficult">
          <Load /> Load Difficult Terms
        </button>
        <button class="btn-outline-dark-light-4 btn" @click="reloadDeck">
          <ReloadDeck /> Reload Deck
        </button>
        <nuxt-link class="btn-outline-dark-light-4 btn" to="/flashcards/">
          <BrowseDeck /> Browse More Decks
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import ShareIcon from '../assets/svg/flashcards/send-result.svg?vue-component';
import ReloadDeck from '../assets/svg/flashcards/reload-deck.svg?vue-component';
import BrowseDeck from '../assets/svg/flashcards/browse-deck.svg?vue-component';
import Load from '../assets/svg/flashcards/load-arrow.svg?vue-component';
import TakeTest from '../assets/svg/flashcards/take-test.svg?vue-component';
import ContinueReviewing from '../assets/svg/flashcards/review-small-eye.svg?vue-component';

export default {
  components: {
    ShareIcon,
    ReloadDeck,
    BrowseDeck,
    Load,
    TakeTest,
    ContinueReviewing,
  },
  props: {
    data: { type: Object, required: false, default: () => ({}) },
    review: Boolean,
  },
  computed: {
    testBtnText() {
      return Object.keys(this.data.testScore).length !== 0 ? 'Take Another Test' : 'Take Test';
    },
  },
  methods: {
    shareResult() {
      this.$store.dispatch('modals/open', {
        name: 'share-results',
        testScore: this.data.testScore,
        deckTitle: this.data.title,
        shortLink: `f/${this.data.testScore.shortLink}/`,
      });
    },
    async reloadDeck() {
      await this.$router.push(`/flashcards/${this.$route.params.slug}/study/`);
    },
    async loadDifficult() {
      await this.$router.push(`/flashcards/${this.$route.params.slug}/study/?difficult=1`);
    },
  },
};
</script>

<style lang="scss">
.next-card {
  .title {
    font-size: 32px;
    font-weight: 500;
    margin-bottom: var(--spacing-20);
  }

  button {
    margin-bottom: var(--spacing-16);
  }

  .btn {
    font-family: Mazzard, sans-serif;
    width: 100%;
    height: 52px;
    display: inline-flex;
    align-items: center;
    padding-left: var(--spacing-40);
    margin-bottom: var(--spacing-16);
    border-color: var(--main-dark-light-4);

    &:hover {
      background: var(--main-light-shade-3);
      color: var(--main-dark-light-4);
    }

    &:active {
      background: var(--main-dark-light-4);
      color: var(--main-light);

      svg {
        path[fill] {
          fill: var(--main-light);
        }

        path[stroke] {
          stroke: var(--main-light);
        }

        g[stroke] {
          stroke: var(--main-light);
        }
      }
    }

    &:last-child {
      margin-bottom: 0;
    }

    svg {
      width: 20px;
      margin-right: var(--spacing-12);
    }
  }
}
</style>
